module.exports = {
  accessToken:
    "pk.eyJ1IjoiamFjb2JrZWF0b24xIiwiYSI6ImNqb2cyd3VsdTBhdjAzdm1ubmJyang5Z3kifQ.oXqW24VBdYNlMQifJpb7EA"
};



// WEBPACK FOOTER //
// ./src/config/mapbox.js